// devsAfterBoard — AUD-05 P3, the Developments double read. Entering Developments used to start
// two reads of `developments` in the same moment: the Board's first page (useDevsPaginated,
// 60 rows, key ['devs-paginated', …]) and the app's full list (useAppDevs, 1,000 rows a page,
// Conv #144). The full list now waits until the Board's first page has ANSWERED — data or
// error — so the Board paints first. It starts at once instead when the open Developments view
// is not the Board (List, By Designer, Archive, … read the full list and nothing else), when a
// Board page has already answered, or when the view moves off the Board while it waits; and it
// starts after FALLBACK_MS whatever happens (kanban mode, no access to the portal, a slow
// network). useDevsPaginated's query is read from the cache, never changed.
import { useUiStore } from "../stores/uiStore";

const BOARD_KEY = "devs-paginated";
export const FALLBACK_MS = 3000;   // the same 3 s the slim items read waits behind a screen's first page

// query.state.status leaves 'pending' only when a fetch has answered; placeholder data does not count.
const answered = (query) => query?.queryKey?.[0] === BOARD_KEY && query.state.status !== "pending";

// Calls start() once — now, or when the Board's first page answers. Returns a cancel function.
export function afterBoardFirstPage(queryClient, start, fallbackMs = FALLBACK_MS) {
  const cache = queryClient.getQueryCache();
  if (useUiStore.getState().devView !== "board" || cache.findAll({ queryKey: [BOARD_KEY] }).some(answered)) {
    start();
    return () => {};
  }
  let live = true;
  const stopCache = cache.subscribe((event) => { if (answered(event?.query)) go(); });
  const stopView = useUiStore.subscribe((state) => { if (state.devView !== "board") go(); });
  const timer = setTimeout(go, fallbackMs);
  function cancel() { if (!live) return; live = false; stopCache(); stopView(); clearTimeout(timer); }
  function go() { if (!live) return; cancel(); start(); }
  return cancel;
}
